import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { pushEvent } from "@/lib/gtm";

export default function ProductCard({ product }) {
  const trackView = () =>
    pushEvent("view_product", { product_name: product.name, category: product.category });
  return (
    <div className="group bg-white border border-gray-200 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:border-[#E4001C]/40 flex flex-col">
      <Link to={`/products/${product.slug || product.id}`} onClick={trackView} className="block overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy" decoding="async"
          className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500" />
      </Link>
      <div className="p-6 flex flex-col flex-1">
        <p className="font-tech uppercase tracking-widest text-xs text-[#E4001C] mb-2">{product.category}</p>
        <Link to={`/products/${product.slug || product.id}`} onClick={trackView}>
          <h3 className="font-tech font-semibold uppercase tracking-wide text-xl text-[#171717] group-hover:text-[#E4001C] transition-colors">{product.name}</h3>
        </Link>
        <p className="text-sm text-[#171717]/60 leading-relaxed mt-3 flex-1 line-clamp-3">{(product.description || "").replace(/<[^>]*>/g, "")}</p>
        <div className="flex items-center justify-between mt-6 gap-3">
          <Link to={`/products/${product.slug || product.id}`} onClick={trackView}
            className="font-tech font-semibold uppercase tracking-widest text-sm text-[#171717] hover:text-[#E4001C] transition-colors inline-flex items-center gap-1">
            View Specs <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to={`/contact?product=${encodeURIComponent(product.name)}`}
            onClick={() => pushEvent("request_quote_click", { location: "product_card", product_name: product.name })}
            className="bg-[#E4001C] hover:bg-[#c00018] text-white font-tech font-semibold uppercase tracking-widest text-xs px-4 py-2.5 transition-colors">
            Request Quote
          </Link>
        </div>
      </div>
    </div>
  );
}